export const notificationConstant = {
    GET_USER_LIST_REQUEST: 'GET_USER_LIST_REQUEST',
    GET_USER_LIST_SUCCESS: 'GET_USER_LIST_SUCCESS',
    GET_USER_LIST_FAILURE: 'GET_USER_LIST_FAILURE',

    GET_NOTIFICATION_LIST_REQUEST: 'GET_NOTIFICATION_LIST_REQUEST',
    GET_NOTIFICATION_LIST_SUCCESS: 'GET_NOTIFICATION_LIST_SUCCESS',
    GET_NOTIFICATION_LIST_FAILURE: 'GET_NOTIFICATION_LIST_FAILURE',


    SEND_NOTIFICATION_REQUEST: "SEND_NOTIFICATION_REQUEST",
    SEND_NOTIFICATION_SUCCESS: "SEND_NOTIFICATION_SUCCESS",
    SEND_NOTIFICATION_FAILURE: "SEND_NOTIFICATION_FAILURE",


}